module.exports = __webpack_public_path__ + "img/score.2c64d136.png";